`use strict`;

(function () {

    document.addEventListener('DOMContentLoaded', () => {

        const toggles = [];
        const traps = [];

        const searchToggles = document.querySelectorAll('.searchform__toggle');
        if (!searchToggles) {
            return;
        }

        searchToggles.forEach((toggle, key) => {

            const mq = window.matchMedia('(min-width: ' + window.breakpoint + 'px)');
            if (mq.matches) {

                toggles[key] = new Draad_Toggle(toggle);

                traps[key] = new Draad_Focus_Trap(toggle.parentNode);

                toggle.addEventListener('DraadToggleOpen', () => {
                    traps[key].active = true;
                });

                toggle.addEventListener('DraadToggleClose', () => {
                    traps[key].active = false;
                });
            }

        });

        // if input type search is active add class to closest div with class input-active
        const searchInputs = document.querySelectorAll('input[type="search"]');

        searchInputs.forEach(searchInput => {
            const div = searchInput.closest('div');

            const toggleActiveClass = () => {
                div.classList.toggle('input-active', searchInput.value !== '');
            };

            const toggleActiveClassOnFocus = () => {
                div.classList.add('input-active');
            };

            const toggleActiveClassOnBlur = () => {
                if (searchInput.value === '') {
                    div.classList.remove('input-active');
                }
            };

            searchInput.addEventListener('input', toggleActiveClass);
            searchInput.addEventListener('focus', toggleActiveClassOnFocus);
            searchInput.addEventListener('blur', toggleActiveClassOnBlur);

            toggleActiveClass();
        });

    });

})();